type ApiErrorPayload = {
  error?: unknown;
  message?: unknown;
};

function errorMessage(payload: unknown, fallback: string) {
  if (!payload || typeof payload !== "object") return fallback;
  const body = payload as ApiErrorPayload;
  if (typeof body.error === "string" && body.error) return body.error;
  if (typeof body.message === "string" && body.message) return body.message;
  return fallback;
}

export async function readJson<T>(response: Response, fallback = "Request failed"): Promise<T> {
  const payload: unknown = await response.json().catch(() => null);
  if (!response.ok) throw new Error(errorMessage(payload, fallback));
  return payload as T;
}

export async function readJsonArray<T>(response: Response, label: string): Promise<T[]> {
  const payload = await readJson<unknown>(response, `Could not load ${label}`);
  if (!Array.isArray(payload)) throw new Error(`Unexpected ${label} response`);
  return payload as T[];
}

export async function readJsonArrayOrEmpty<T>(response: Response): Promise<T[]> {
  if (!response.ok) return [];
  const payload: unknown = await response.json().catch(() => null);
  return Array.isArray(payload) ? payload as T[] : [];
}